module.exports = __webpack_public_path__ + "img/my_redpack_tips_info_bg.b639e2f1.png";